import { render, staticRenderFns } from "./subjectManuscript.vue?vue&type=template&id=6fad5571"
import script from "./subjectManuscript.vue?vue&type=script&lang=js"
export * from "./subjectManuscript.vue?vue&type=script&lang=js"
import style0 from "./subjectManuscript.vue?vue&type=style&index=0&id=6fad5571&prod&lang=css"
import style1 from "./subjectManuscript.vue?vue&type=style&index=1&id=6fad5571&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports